<template>
  <div>
    <main class="container">
      <table-header
        title="Список дилеров"
        :is-loading="isLoading"
        :is-empty="!dealers.length"
      >
        <button
          class="btn btn-primary-ford-orange white"
          @click="exportCSV"
        >
          <i class="material-icons">file_download</i>
          Выгрузить в xls
        </button>
        <filter-dealers @applyFilters="applyFilters" />
      </table-header>
      <div class="table-wrapper">
        <div class="table-container">
          <transition
            name="fade"
            mode="out-in"
          >
            <table
              v-if="!isLoading && dealers.length"
              class="table"
            >
              <thead>
                <tr>
                  <th
                    v-for="header in tableHeaders"
                    :key="header"
                  >
                    <div class="table__header">
                      {{ header }}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="it in dealers"
                  :key="it.id"
                >
                  <td>{{ it.name }}</td>
                  <td>{{ it.phone }}</td>
                  <td>{{ it.email }}</td>
                  <td>{{ it.URCode }}</td>
                </tr>
              </tbody>
            </table>
          </transition>
        </div>
      </div>
      <table-footer
        v-if="dealers.length && !isLoading"
        :current-page="currentPage"
        :per-page="perPage"
        :limit="limit"
        :total-count="totalCount"
        @pageChanged="(page) => currentPage = page"
        @limitChanged="(lim) => limit = lim"
      />
    </main>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TableHeader from '@/components/table/TableHeader';
import TableFooter from '@/components/table/TableFooter';
import FilterDealers from '@/components/dealers/FilterDealers';

export default {
  name: 'DealerList',
  components: {
    TableHeader,
    TableFooter,
    FilterDealers,
  },
  data: () => ({
    isLoading: true,
    dealers: [],
    tableHeaders: ['Дилер', 'Телефон', 'E-mail', 'UR'],
    currentPage: 1,
    perPage: 10,
    limit: 10,
    totalCount: null,
    isFilterShown: false,
    filters: {},
    pageWatcherDisabled: false,
  }),
  computed: {
    ...mapState(['isBackgroundBlurred']),
    pages() {
      return Math.ceil(this.totalCount / this.perPage);
    },
    offset() {
      return this.limit * (this.currentPage - 1);
    },
  },
  watch: {
    limit() {
      this.pageWatcherDisabled = true;
      this.currentPage = 1;
      this.getDealers();
    },
    currentPage() {
      if (this.pageWatcherDisabled) {
        return;
      }

      this.getDealers();
    },
  },
  created() {
    this.getDealers();
  },
  methods: {
    async getDealers() {
      this.isLoading = true;
      const { items, totalCount } = await this.$http.get('dealers/1.0/dealers', {
        params: {
          limit: this.limit,
          skip: this.offset,
          ...this.filters,
        },
      });

      this.isLoading = false;

      this.dealers = items;
      this.totalCount = totalCount;
      this.perPage = this.limit;
      this.pageWatcherDisabled = false;
    },
    async updateDealers() {
      this.filters = {};
      this.pageWatcherDisabled = true;
      this.currentPage = 1;

      this.getDealers();
    },
    applyFilters(filters) {
      this.filters = filters;
      this.pageWatcherDisabled = true;
      this.currentPage = 1;
      this.getDealers();
    },
    async exportCSV() {
      this.$http.get('/dealers/1.0/dealers-xlsx', {
        responseType: 'blob',
      }).then(response => {
        const href = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', 'dealers.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
  },
};
</script>
